import React from 'react';
import { CloseOutlined, GdprColored } from '@zbanx/icons';
import { Button } from '@zbanx-coding/components-basic';
import { useTranslation } from 'react-i18next';
import { getGdprState, setGdprState } from '@/utils/gdpr';
import { useAppContext } from '@/hooks/useAppContext';
import css from './index.less';

export interface Props {}

export const GdprMessage: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { gdprMessageStatus, updateAppContext } = useAppContext();

  const onAccept = React.useCallback(() => {
    setGdprState({ status: 'accept' });
    updateAppContext({ gdprMessageStatus: 'accept' });
  }, [updateAppContext]);

  const onDecline = React.useCallback(() => {
    setGdprState({ status: 'reject' });
    updateAppContext({ gdprMessageStatus: 'reject' });
  }, [updateAppContext]);

  React.useEffect(() => {
    if (!gdprMessageStatus) {
      const state = getGdprState();
      if (state.status === 'unknown') {
        updateAppContext({ gdprMessageStatus: 'visible' });
      }
    }
  }, [gdprMessageStatus]);

  if (gdprMessageStatus !== 'visible') {
    return null;
  }

  return (
    <div key="gdprMessage" className={css.gdprMessage}>
      <p className={css.title}>
        <GdprColored />
        <span>{t('biz.gdpr.title')}</span>
        <span className={css.close}>
          <CloseOutlined
            onClick={() => {
              updateAppContext({ gdprMessageStatus: 'closed' });
            }}
          />
        </span>
      </p>
      <p className={css.content}>{t('biz.gdpr.content')}</p>
      <div>
        <Button
          onClick={onAccept}
          className={css.btnAccept}
          size="large"
          type="primary"
          brand
        >
          {t('biz.gdpr.accept')}
        </Button>
        <Button size="large" onClick={onDecline}>
          {t('biz.gdpr.decline')}
        </Button>
      </div>
    </div>
  );
};

export default GdprMessage;
